import { render, staticRenderFns } from "./SPIFProfileHeader.vue?vue&type=template&id=4ed873b7"
import script from "./SPIFProfileHeader.vue?vue&type=script&lang=js"
export * from "./SPIFProfileHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports